<template>
  <v-toolbar
    v-bind:color="toolbarColor"
    app
    dark
    class="botToolbar"
  >
    <img class="botToolbar--logo" v-if="toolbarLogo" v-bind:src="toolbarLogo"/>

    <v-menu v-if="isEnableLogin" offset-y>

      <v-btn
        slot="activator"
        dark
        icon
      >
        <v-icon>
          {{'menu'}}
        </v-icon>
      </v-btn>

      <v-list>
        <v-list-tile>
          <v-list-tile-title v-if="isLoggedIn" v-on:click="requestLogout">{{ items[1].title }}</v-list-tile-title>
          <v-list-tile-title v-if="!isLoggedIn" v-on:click="requestLogin">{{ items[0].title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-toolbar-title class="hidden-xs-and-down botToolbar--title">
      {{ toolbarTitle }}
    </v-toolbar-title>

    <v-toolbar-title class="hidden-xs-and-down">
      {{ userName }}
    </v-toolbar-title>

    <v-spacer />
    <!-- tooltip should be before btn to avoid right margin issue in mobile -->
    <v-tooltip
      v-model="shouldShowTooltip"
      activator=".min-max-toggle"
      left
    >
      <span id="min-max-tooltip">{{toolTipMinimize}}</span>
    </v-tooltip>
    <v-btn
      v-if="$store.state.isRunningEmbedded"
      v-on:click="toggleMinimize"
      v-on="tooltipEventHandlers"
      class="min-max-toggle"
      icon
    >
      <v-icon>
        {{ isUiMinimized ?  'arrow_drop_up' : 'arrow_drop_down' }}
      </v-icon>
    </v-btn>
    <account-actions></account-actions>
  </v-toolbar>
</template>

<script>
/*
Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
import AccountActions from './user/AccountActions';

export default {
  name: 'toolbar-container',
  components: {
    AccountActions,
  },
  data() {
    return {
      items: [
        { title: 'Login' },
        { title: 'Logout' },
      ],
      shouldShowTooltip: false,
      tooltipEventHandlers: {
        mouseenter: this.onInputButtonHoverEnter,
        mouseleave: this.onInputButtonHoverLeave,
        touchstart: this.onInputButtonHoverEnter,
        touchend: this.onInputButtonHoverLeave,
        touchcancel: this.onInputButtonHoverLeave,
      },
    };
  },
  props: ['toolbarTitle', 'toolbarColor', 'toolbarLogo', 'isUiMinimized', 'userName'],
  computed: {
    toolTipMinimize() {
      return (this.isUiMinimized) ? 'maximize' : 'minimize';
    },
    isEnableLogin() {
      return this.$store.state.config.ui.enableLogin;
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
  },
  methods: {
    onInputButtonHoverEnter() {
      this.shouldShowTooltip = true;
    },
    onInputButtonHoverLeave() {
      this.shouldShowTooltip = false;
    },
    toggleMinimize() {
      this.onInputButtonHoverLeave();
      this.$emit('toggleMinimizeUi');
    },
    requestLogin() {
      this.$emit('requestLogin');
    },
    requestLogout() {
      this.$emit('requestLogout');
    },
    toggleIsLoggedIn() {
      this.onInputButtonHoverLeave();
      this.$emit('toggleIsLoggedIn');
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Shadows+Into+Light');
.botToolbar {
  background: #ee2024 !important;
  background-color: #ee2024 !important;
  border-color: #ee2024 !important;
}
.botToolbar--logo {
  width: auto;
  height: 85%;
}
.botToolbar--title {
  font-family: 'Shadows Into Light', cursive;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: 0.05em;
}
@media only screen and (max-width: 599px) {
  .botToolbar--logo {
    margin-left: 10px !important;
    height: 70%;
  }
  .botToolbar--title {
    font-size: 16px;
    margin-left: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ToolbarContainer.vue